import Vue from "vue";

export default {
  mFinishedLoading(state) {
    state.loadingapp = false;
  },
  mShowLongLoader(state, payload) {
    state.longloader.message = payload;
    state.longloader.show = true;
  },
  mHideLongLoader(state) {
    state.longloader.show = false;
    state.longloader.message = "";
  },
  mShowErrorMessage(state, payload) {
    state.errormessage = payload;
    setTimeout(() => {
      state.errormessage = "";
    }, 5000);
  },

  mShowInfoMessage(state, payload) {
    state.infomessage = payload;
    setTimeout(() => {
      state.infomessage = "";
    }, 5000);
  },

  mLogin(state, payload) {
    state.user = payload.user;
    state.userRole = (payload.user || {}).roleName;

    let authToken = payload.authtoken;

    Vue.axios.defaults.headers.post["X-PSYSTEM-AUTH"] = authToken;
    Vue.axios.defaults.headers.common["X-PSYSTEM-AUTH"] = authToken;

    sessionStorage.authToken = authToken;
    sessionStorage.authUser = JSON.stringify(state.user);

    Vue.$log.debug("mLogin: ", payload.authtoken);
    Vue.$auth(payload.authtoken);
  },

  mLogout(state) {
    Vue.$logout();
    state.user = undefined;

    // a bit of house-cleaning
    delete sessionStorage.authToken;
    delete sessionStorage.authUser;
    delete sessionStorage.currentDpr;
    delete sessionStorage.currentDprHeader;
  },

  SET_NOOP: () => {},


  //// --------------------------

  mProjectsNames(state, payload) {
    state.projectsNames = payload;
    state.projectsNames.unshift({
      Id: 0,
      Name: "Select Project"
    });
  },
  mVesselNames(state, payload) {
    state.vesselNames = payload;
    state.vesselNames.unshift({
      ID: 0,
      DESCRIPTION: "Select Asset"
    });
  },

  mActivityType(state, payload) {
    state.activityTypes = payload;
  },

  mActivityCategory(state, payload) {
    state.activityCategories = payload;
  },

  mMaxCode(state, payload) {
    state.maxedCode = payload;
  },

  mNextSeqCode(state, {
    payload,
    entity
  }) {
    state.maxedCode = payload;
    if (entity) {
      state.nextSeqCode[entity] = payload;
    }
  },

  mActivityMaster(state, payload) {
    state.activityMaster = payload;
  },

  mProjects(state, payload) {
    state.projects = payload;
  },

  mVessels(state, payload) {
    state.vessels = payload;
  },

  mTools(state, payload) {
    state.tools = payload;
  },

  mCable(state, payload) {
    state.cables = payload;
  },

  mMacroActivities(state, payload) {
    state.macroActivities = payload
  },

  mSoil(state, payload) {
    state.soils = payload
  },

  mProjectsInVessel(state, payload) {
    state.projectsInVessel = payload
  },

  mProject(state, payload) {
    state.project = payload;
  },

  mActivityConfigurations(state, payload) {
    state.activityConfigurations = payload;
  },
  mTrenchers(state, payload) {
    state.trenchers = payload;
  },
  mConfigurations(state, payload) {
    state.configurations = payload;
  },
  mQhse(state, payload) {
    state.qhse = payload;
  },
  mEquipmentStatus(state, payload) {
    state.equipmentStatus = payload;
  },
  mAreas(state, payload) {
    state.areas = payload;
  },

  mUnassignedVessels: (state, payload) => {
    state.vesselList = payload; // backwards compatibility

    state.unassignedVessels = {};
    (payload || []).forEach(v => state.unassignedVessels[v.VesselId] = v);
  },

  SET_PROJECT_STATUSES: (state, payload) => {
    let statuses = {};
    (payload || []).forEach(ps => statuses[ps.id] = ps);
    state.globalContext.pstatuses = statuses;

    state.projectStatuses = payload;
    state.projectStatuses.unshift({
      id: 0,
      description: "All"
    });
  },

  SET_PROJECT_VESSELS_MAPPINGS: (state, payload) => state.projectVesselMappings = payload || [],

  mEstimates(state, payload) {
    state.estimates = payload;
  },

  mComputers(state, payload) {
    state.computers = payload;
  },

  mProjectsInComputer(state, payload) {
    state.projectsInComputer = payload;
  },


};